import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../layout-flex/types/index.esm.js';
import '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-date-picker.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSDatePickerInput extends React.Component {
  static displayName = 'EGDSDatePickerInput';
  render() {
    const {
      cssClassNames,
      isDialog,
      onClick,
      selection,
      selectionDateMsg,
      singleMode,
      selectionDate
    } = this.props;
    const selectionButtonClasses = getClassNameList(cssClassNames, {
      'selection-filled': selection,
      'uitk-date-picker-input': selection && !isDialog
    });
    const grow = isDialog && !singleMode ? 1 : undefined;
    return jsx(EGDSLayoutFlexItem, {
      grow: grow,
      className: selectionButtonClasses,
      minWidth: singleMode ? 'half_width' : undefined,
      children: jsx("button", {
        type: "button",
        onClick: onClick,
        children: jsxs("span", {
          className: getClassNameList('uitk-date-picker-selection-date'),
          children: [selectionDate, selectionDateMsg && jsxs("span", {
            className: "is-visually-hidden",
            children: [": ", selectionDateMsg]
          })]
        })
      })
    });
  }
}
const EGDSNewDatePickerInput = EGDSDatePickerInput;
export { EGDSDatePickerInput, EGDSNewDatePickerInput };